'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageAttachmentPreview = function (_React$Component) {
  _inherits(ImageAttachmentPreview, _React$Component);

  function ImageAttachmentPreview(props) {
    _classCallCheck(this, ImageAttachmentPreview);

    var _this = _possibleConstructorReturn(this, (ImageAttachmentPreview.__proto__ || Object.getPrototypeOf(ImageAttachmentPreview)).call(this, props));

    _this.state = {
      imageDataUrl: ''
    };
    return _this;
  }

  _createClass(ImageAttachmentPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.processImageFile(this.props.imageFile);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.imageFile !== this.props.imageFile) {
        this.processImageFile(nextProps.imageFile);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.imageDataUrl !== this.state.imageDataUrl;
    }
  }, {
    key: 'processImageFile',
    value: function processImageFile(imageFile) {
      var _this2 = this;

      var reader = new FileReader();

      reader.addEventListener('load', function () {
        _this2.setState({
          imageDataUrl: reader.result
        });
      });

      reader.readAsDataURL(imageFile);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_UIImage2.default, { src: this.state.imageDataUrl });
    }
  }]);

  return ImageAttachmentPreview;
}(_react2.default.Component);

ImageAttachmentPreview.propTypes = {
  imageFile: _react.PropTypes.instanceOf(File).isRequired // eslint-disable-line conversations/use-record-proptype
};

exports.default = ImageAttachmentPreview;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/attachments/ImageAttachmentPreview.js
// module id = 1164
// module chunks = 2 3